import React from 'react';
import { classNames } from 'primereact/utils';

/**
 * 터치·태블릿에서 선택하기 쉬운 큰 타일 버튼 (radio / checkbox)
 */
const WheelOptionTiles = ({
  options = [],
  value,
  onChange,
  type = 'radio',
  max,
  disabled = false,
  layout = 'horizontal',
  tileClassName = '',
}) => {
  const isSelected = (optValue) => {
    if (type === 'checkbox') {
      return (value || []).includes(optValue);
    }
    return value === optValue;
  };

  const handleClick = (optValue, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (disabled) return;

    if (type === 'checkbox') {
      const current = value || [];
      const checked = current.includes(optValue);
      if (checked) {
        onChange(current.filter((v) => v !== optValue));
        return;
      }
      if (max && current.length >= max) return;
      onChange([...current, optValue]);
      return;
    }

    onChange(optValue);
  };

  return (
    <div
      className={classNames('wheel-option-tiles', {
        'wheel-option-tiles--vertical': layout === 'vertical',
        'wheel-option-tiles--grid-2x2': layout === 'grid2x2',
      })}
    >
      {options.map(({ label, value: optValue }) => (
        <button
          key={optValue}
          type="button"
          disabled={disabled}
          className={classNames(
            'wheel-option-tile',
            tileClassName,
            { 'wheel-option-tile--selected': isSelected(optValue) }
          )}
          onClick={(e) => handleClick(optValue, e)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default WheelOptionTiles;
